export const testing = {
  value: true,
};

export const logger = { log: (msg: string) => console.log(msg) };
